import { css } from '@emotion/core';
import { variables, media } from '@domain-group/fe-brary';
var global = variables.global;
export var listingCards = /*#__PURE__*/css("margin:24px 16px 0;", media('>=desktop'), "{width:", global.desktopMinWidth, ";margin:24px 0 0 0;}");
export var recommendations = /*#__PURE__*/css("padding-bottom:5px;", media('<desktop'), "{padding:0 16px 5px;}");